export default {
	// H5渠道
	H5AppSaleChannel: 7,
	// 微信登陆
	WeiXinwechatLogin: 'AccountService_WeChatLoginHandler',
	// x舱活动首页
	CabinActiveService_GetActivityList: 'CabinActiveService_GetActivityList',
	// 用户类型
	orderChannel: 2,//2 外部用户 1 内部用户
	// 商城类型
	mallType: 1,//1 云商城 2 积分商城
	fpObj: {
		'searchFlightsNew': true,
		'SpecialService_SpecialServiceDetrTNHandler2': true,
        'searchConnectFlights': true,
	},
	b: '7210EC47D15DDEA5914805946E57E02C', // mima
}



// WEBPACK FOOTER //
// ./src/interfaces/globalname.js